import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TheBorder} from "../TheBorder";
import {TimelineLite, TweenLite} from "gsap";
import {TheBorderStatics} from "../TheBorderStatics";
import {TheBorderSound} from "../sound/TheBorderSound";
import {TheBorderGameMode} from "../server/TheBorderGameMode";

export class TheBorderSwooshAnimationView extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "TheBorderSwooshAnimationView";
        this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
    }

    public playSwoosh(xPos:number, yPos:number, toXPos:number, toYPos:number, canPlaySound: boolean = true):TimelineLite {
        if(TheBorder.model.data.mode == TheBorderGameMode.FREESPIN || TheBorder.model.data.mode == TheBorderGameMode.FREESPIN_AVALANCHE) {
            toXPos -= 120;
            toYPos -= 34;
        } else if(TheBorder.model.data.mode == TheBorderGameMode.SUPER_FREESPIN || TheBorder.model.data.mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE) {
            toXPos -= 50;
            toYPos -= 14;
        }
        const tl:TimelineLite = new TimelineLite(),
            duration:number = (5 / 30),
            swoosh:PIXI.Sprite = new PIXI.Sprite(TheBorder.assetLoader.getTextures("M_blast_00")[0]),
            blast:TimelineSprite = new TimelineSprite(TheBorder.assetLoader.getTextures("win_multiplier_blast/win_multiplier_blast_"));

        blast.hide();
        blast.anchor.set(0.5);
        blast.position.set(toXPos, toYPos);
        blast.blendMode = PIXI.BLEND_MODES.ADD;

        swoosh.visible = false;
        swoosh.anchor.set(0.5);
        swoosh.blendMode = PIXI.BLEND_MODES.ADD;

        tl.add(() => {
            swoosh.position.set(xPos, yPos);
            swoosh.scale.set(1);
            swoosh.visible = true;
            this.addChild(swoosh);
            if (canPlaySound) {
                TheBorder.soundPlayer.playSound(TheBorderSound.MULTIPLIER_SWOSH_SOUNDS[Math.floor(Math.random() * TheBorderSound.MULTIPLIER_SWOSH_SOUNDS.length)]);
            }
            TweenLite.to(swoosh, {
                duration : duration,
                x : toXPos,
                y : toYPos
            });
            TweenLite.to(swoosh.scale, {
                duration : duration,
                x : 0.5,
                y : 0.5
            });
        }, 0);
        tl.add(() => {
            swoosh.visible = false;
            if(swoosh.parent) {
                swoosh.parent.removeChild(swoosh);
            }

            blast.show();
            this.addChild(blast);
            blast.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
                if(blast.parent) {
                    blast.parent.removeChild(blast);
                }
            }).timeScale(0.5);
        }, duration);

        return tl;
    }
}